import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import { formatCurrency } from './formatters';

const MARGIN = 14;

// Monta o PDF a partir dos mesmos dados exibidos na tela: cabeçalho com o período
// e os filtros, os totais e a listagem agrupada, na ordem em que aparecem.
export function buildClinicalProductionPdf({
  selectedDate,
  statusLabel,
  groupByLabel,
  summary,
  groups,
}) {
  const pdf = new jsPDF({ unit: 'mm', format: 'a4' });

  pdf.setFontSize(16);
  pdf.text('Produção clínica', MARGIN, 20);

  pdf.setFontSize(10);
  pdf.setTextColor(110);
  pdf.text(
    `Período ${selectedDate.format('MM/YYYY')} · ${statusLabel} · ${groupByLabel}`,
    MARGIN,
    27,
  );
  pdf.setTextColor(0);

  autoTable(pdf, {
    startY: 34,
    theme: 'plain',
    tableWidth: 90,
    styles: { fontSize: 10, cellPadding: 1.5 },
    columnStyles: { 0: { textColor: 110 }, 1: { halign: 'right', fontStyle: 'bold' } },
    body: [
      ['Total produzido', summary.totalProducedFormatted],
      ['Procedimentos', String(summary.proceduresCount)],
      ['Recebido', `${summary.totalReceivedFormatted} (${summary.receivedPercentage}%)`],
      ['A receber', summary.totalToReceiveFormatted],
    ],
  });

  const { rows, groupRowIndexes } = toTableRows(groups);

  autoTable(pdf, {
    startY: pdf.lastAutoTable.finalY + 6,
    head: [['Procedimento', 'Data', 'Valor']],
    body: rows,
    styles: { fontSize: 9, cellPadding: 2 },
    headStyles: { fillColor: [240, 240, 240], textColor: 60 },
    columnStyles: { 1: { cellWidth: 24 }, 2: { cellWidth: 30, halign: 'right' } },
    didParseCell: (data) => {
      if (data.section === 'body' && groupRowIndexes.has(data.row.index)) {
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.fillColor = [248, 248, 248];
      }
    },
  });

  pdf.save(`producao-clinica-${selectedDate.format('MM-YYYY')}.pdf`);
}

// Cada grupo vira uma linha de cabeçalho seguida das linhas dos seus procedimentos.
// Os índices dos cabeçalhos voltam junto para que recebam o destaque na tabela.
function toTableRows(groups) {
  const rows = [];
  const groupRowIndexes = new Set();

  groups.forEach((group) => {
    groupRowIndexes.add(rows.length);
    rows.push([group.title, '', formatCurrency(group.total)]);

    group.items.forEach((item) => {
      const procedure = item.tooth
        ? `${item.procedureName} · dente ${item.tooth}`
        : item.procedureName;

      rows.push([
        item.subtitle ? `${procedure}\n${item.subtitle}` : procedure,
        item.executionDate ?? '',
        item.amountFormatted ?? '',
      ]);
    });
  });

  return { rows, groupRowIndexes };
}
